import { Feedback } from 'SharedDir/declarations/feedback';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import {
  FEEDBACK,
} from 'SharedDir/backend/endpoints/feedbacks';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';

export default class FeedbackApiClass {
  public static async list<Extra extends object>(
    params: PaginationParams<Extra>
  ): Promise<Feedback[]> {
    const responseData: Feedback[] = await http({
      ...FEEDBACK.LIST,
      params
    })
      .then((r): Feedback[] => r.data.data);

    return responseData;
  }

  public static async create(data: Feedback): Promise<Feedback> {
    const responseData: Feedback = await http({
      ...FEEDBACK.STORE,
      data,
    })
      .then((r): Feedback => r.data);

    return responseData;
  }
}
